import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Hook zum Scrollen zu Sektionen mit vorheriger Navigation zur Homepage wenn nötig
 */
export const useScrollToSection = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId, callback) => {
    // Wenn wir nicht auf der Homepage sind, erst dorthin navigieren
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } });
      if (callback) callback();
      return;
    }

    // Wenn wir bereits auf der Homepage sind, direkt scrollen
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      if (callback) callback();
    }
  };

  return scrollToSection;
};
